import { isAuthenticated } from '../common/permissions';
import NotificationsPage from './NotificationsPage';

export default [
  {
    exact: true,
    path: '/notifications',
    permissions: [isAuthenticated],
    component: NotificationsPage,
  },
];
